/// <amd-module name="SuiteCommerce.Blog.PostList.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostList.View", ["require", "exports", "Backbone", "Backbone.CollectionView", "SuiteCommerce.Blog.Post.Collection", "SuiteCommerce.Blog.Post.Model", "SuiteCommerce.Blog.PostCard.View", "sc_blog_post_list.tpl"], function (require, exports, Backbone_1, BackboneCollectionView, Post_Collection_1, Post_Model_1, PostCard_View_1, postListTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PostListView = /** @class */ (function (_super) {
        __extends(PostListView, _super);
        function PostListView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = postListTemplate;
            _this.setupModelListener();
            return _this;
        }
        PostListView.prototype.setupModelListener = function () {
            var _this = this;
            this.model.on('change', function () {
                _this.render();
            });
        };
        Object.defineProperty(PostListView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'PostCards.View': function () {
                        return _this.getPostCardCollectionViewConstructor();
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        PostListView.prototype.getPostCardCollectionViewConstructor = function () {
            var postCards;
            if (this.model.showPostCardsPlaceholders) {
                postCards = new Post_Collection_1.PostCollection();
                for (var i = 0; i < this.model.postCardPlaceholdersQuantity; i += 1) {
                    postCards.add(new Post_Model_1.PostModel());
                }
            }
            else {
                postCards = this.model.posts;
            }
            return new BackboneCollectionView({
                childView: PostCard_View_1.PostCardView,
                collection: postCards,
                childViewOptions: {
                    layout: this.model.postCardLayout,
                    highlightInCard: this.model.highlightInCards,
                },
            });
        };
        PostListView.prototype.getContext = function () {
            return {
                title: this.model.title,
                hideList: this.model.hideList,
            };
        };
        return PostListView;
    }(Backbone_1.View));
    exports.PostListView = PostListView;
});
